
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project-solutions",
      function () {
        return require("private-next-pages/project-solutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project-solutions"])
      });
    }
  